'use client'

import { useEffect } from 'react'
import ErrorState from '@/components/custom/ErrorState'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error)
    }, [error])

    return (
        <html>
            <body>
                <ErrorState
                    error={error}
                    reset={reset}
                    title='Something went wrong!'
                    description='We apologize for the inconvenience. An unexpected error occurred.'
                />
            </body>
        </html>
    )
}
